import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import s from './TeacherThemes.module.css';
import gs from './TeacherGroups.module.css';

const EMPTY_FORM = {
  nomi: '',
  oraliq: '',
  Nsavol: '',
  Asavol: '',
  vaqt: '',
  dostup: false,
};

export const TeacherGroups = () => {
  const { user } = useAuth();
  const token = localStorage.getItem('token');

  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [view, setView] = useState('list');
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState(EMPTY_FORM);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [deleteId, setDeleteId] = useState(null);
  const [togglingId, setTogglingId] = useState(null);

  const fetchGroups = async () => {
    setLoading(true);
    try {
      const res = await fetch('https://api.aiassessment.uz/api/gruh/', {
        headers: { Authorization: `Token ${token}` },
      });
      const data = await res.json();
      setGroups(Array.isArray(data) ? data : []);
    } catch {
      setError("Ma'lumotlarni yuklashda xatolik");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchGroups(); }, []);

  const openCreate = () => {
    setForm(EMPTY_FORM);
    setEditingId(null);
    setError('');
    setSuccess('');
    setView('form');
  };

  const openEdit = (g) => {
    setForm({
      nomi: g.nomi ?? '',
      oraliq: g.oraliq ?? '',
      Nsavol: g.Nsavol ?? '',
      Asavol: g.Asavol ?? '',
      vaqt: g.vaqt ?? '',
      dostup: g.dostup ?? false,
    });
    setEditingId(g.id);
    setError('');
    setSuccess('');
    setView('form');
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    setSuccess('');

    const body = {
      nomi: form.nomi,
      oraliq: Number(form.oraliq),
      Nsavol: Number(form.Nsavol),
      Asavol: Number(form.Asavol),
      vaqt: form.vaqt !== '' ? Number(form.vaqt) : null,
      dostup: form.dostup,
      user: user?.id,
    };

    try {
      const url = editingId
        ? `https://api.aiassessment.uz/api/gruh/${editingId}/`
        : 'https://api.aiassessment.uz/api/gruh/';
      const method = editingId ? 'PATCH' : 'POST';

      const res = await fetch(url, {
        method,
        headers: {
          Authorization: `Token ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });

      if (!res.ok) {
        const err = await res.json();
        setError(JSON.stringify(err));
      } else {
        setSuccess(editingId ? 'Guruh yangilandi!' : 'Guruh qo\'shildi!');
        await fetchGroups();
        setTimeout(() => setView('list'), 1200);
      }
    } catch {
      setError('Server bilan bog\'lanishda xatolik');
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async () => {
    if (!deleteId) return;
    try {
      await fetch(`https://api.aiassessment.uz/api/gruh/${deleteId}/`, {
        method: 'DELETE',
        headers: { Authorization: `Token ${token}` },
      });
      setDeleteId(null);
      await fetchGroups();
    } catch {
      setError('O\'chirishda xatolik');
    }
  };

  const toggleDostup = async (g) => {
    setTogglingId(g.id);
    try {
      await fetch(`https://api.aiassessment.uz/api/gruh/${g.id}/`, {
        method: 'PATCH',
        headers: {
          Authorization: `Token ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ dostup: !g.dostup }),
      });
      await fetchGroups();
    } finally {
      setTogglingId(null);
    }
  };

  return (
    <div className={s.page}>
      <div className={s.header}>
        <h1 className={s.title}>Guruhlar boshqaruvi</h1>
        {view === 'list' ? (
          <button className={s.btnPrimary} onClick={openCreate}>+ Yangi guruh</button>
        ) : (
          <button className={s.btnSecondary} onClick={() => setView('list')}>← Ro'yxatga qaytish</button>
        )}
      </div>

      {view === 'list' && (
        loading ? (
          <p className={s.loading}>Yuklanmoqda...</p>
        ) : (
          <div className={s.tableWrapper}>
            <table className={s.table}>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Guruh nomi</th>
                  <th>Maks. ball</th>
                  <th>Naz. savollar</th>
                  <th>Amal. savollar</th>
                  <th>Vaqt (min)</th>
                  <th>ON kirish</th>
                  <th>Amallar</th>
                </tr>
              </thead>
              <tbody>
                {groups.length === 0 && (
                  <tr><td colSpan={8} style={{ textAlign: 'center', color: '#888' }}>Guruhlar yo'q</td></tr>
                )}
                {groups.map((g, idx) => (
                  <tr key={g.id}>
                    <td>{idx + 1}</td>
                    <td className={s.tdTitle}>{g.nomi}</td>
                    <td><span className={s.badge}>{g.oraliq}</span></td>
                    <td>{g.Nsavol}</td>
                    <td>{g.Asavol}</td>
                    <td>{g.vaqt ?? '—'}</td>
                    <td>
                      <button
                        className={`${gs.toggleBtn} ${g.dostup ? gs.toggleOn : gs.toggleOff}`}
                        onClick={() => toggleDostup(g)}
                        disabled={togglingId === g.id}
                        title={g.dostup ? 'Yopish' : 'Ochish'}
                      >
                        {togglingId === g.id ? '...' : g.dostup ? 'Ochiq ✓' : 'Yopiq'}
                      </button>
                    </td>
                    <td className={s.tdActions}>
                      <button className={s.btnEdit} onClick={() => openEdit(g)}>✏️</button>
                      <button className={s.btnDelete} onClick={() => setDeleteId(g.id)}>🗑</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )
      )}

      {view === 'form' && (
        <form className={s.form} onSubmit={handleSubmit}>
          <h2 className={s.formTitle}>
            {editingId ? 'Guruhni tahrirlash' : 'Yangi guruh qo\'shish'}
          </h2>

          <div className={s.field}>
            <label>Guruh nomi *</label>
            <input name="nomi" value={form.nomi} onChange={handleChange} required className={s.input} placeholder="Masalan: AT-24" />
          </div>

          <div className={s.row}>
            <div className={s.field}>
              <label>Maksimal ball (oraliq) *</label>
              <input type="number" name="oraliq" value={form.oraliq} onChange={handleChange} required min={0} className={s.input} />
            </div>
            <div className={s.field}>
              <label>Nazariy savollar soni *</label>
              <input type="number" name="Nsavol" value={form.Nsavol} onChange={handleChange} required min={0} className={s.input} />
            </div>
            <div className={s.field}>
              <label>Amaliy savollar soni *</label>
              <input type="number" name="Asavol" value={form.Asavol} onChange={handleChange} required min={0} className={s.input} />
            </div>
          </div>

          <div className={s.row}>
            <div className={s.field}>
              <label>ON vaqti (daqiqa)</label>
              <input type="number" name="vaqt" value={form.vaqt} onChange={handleChange} min={1} className={s.input} placeholder="Masalan: 30" />
            </div>
            <div className={`${s.field} ${gs.dostupField}`}>
              <label>ON kirishga ruxsat (dostup)</label>
              <label className={gs.switchLabel}>
                <input type="checkbox" name="dostup" checked={form.dostup} onChange={handleChange} className={gs.switchInput} />
                <span className={`${gs.switch} ${form.dostup ? gs.switchOn : ''}`} />
                <span className={gs.switchText}>{form.dostup ? 'Ochiq' : 'Yopiq'}</span>
              </label>
            </div>
          </div>

          {error && <p className={s.error}>{error}</p>}
          {success && <p className={s.successMsg}>{success}</p>}

          <div className={s.formActions}>
            <button type="submit" className={s.btnPrimary} disabled={saving}>
              {saving ? 'Saqlanmoqda...' : (editingId ? 'Yangilash' : 'Saqlash')}
            </button>
            <button type="button" className={s.btnSecondary} onClick={() => setView('list')}>
              Bekor qilish
            </button>
          </div>
        </form>
      )}

      {deleteId && (
        <div className={s.modalOverlay}>
          <div className={s.modal}>
            <h3>Guruhni o'chirish</h3>
            <p>Haqiqatan ham bu guruhni o'chirmoqchimisiz?</p>
            <div className={s.modalActions}>
              <button className={s.btnDelete} onClick={handleDelete}>O'chirish</button>
              <button className={s.btnSecondary} onClick={() => setDeleteId(null)}>Bekor qilish</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
